import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  addPromptConfig,
  deletePromptConfig,
  editPromptConfig,
  getAllConditionPromptConfig,
  getAllPromptScreenConditionConfig,
  getAllPromptScreensConfig,
  getFilterPromptConfig,
  getLLmVersionsConfig,
  getPromptByIdConfig,
} from '../lib/prompts.url';
import { superAdminLoadingSlice } from '../slices/condition.slice';
import { showToastError } from 'src/utilities/errortoast';
import { getAllPromptsListSlice } from '../slices';
import { showToastSuccess } from 'src/utilities/toast';
import {
  getConditionPromptSlice,
  getLLmVersionSlice,
  getPromptScreenConditionSlice,
  getPromptScreensSlice,
  getPromptsByIdSlice,
} from '../slices/prompts.slice';

export const addPromptAction = (
  payload,
  setIsOpen,
  setLlmVersionSelected,
  setDescription,
  setPromptScreenSelected,
  selectedSpecialty,
  selectedCondition
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = addPromptConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Prompt created successfully');
        setIsOpen(false);
        dispatch(getFilterPrompt(selectedSpecialty, selectedCondition));
        setLlmVersionSelected && setLlmVersionSelected(false);
        setPromptScreenSelected && setPromptScreenSelected(false);
        setDescription && setDescription(null);
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const getLLmVersiosnsActions = () => {
  return async (dispatch) => {
    try {
      const { url } = getLLmVersionsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.LLM_versions;
      if (result?.status === 200 && response) {
        dispatch(getLLmVersionSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('No data available');
    }
  };
};

export const getPromptByIdAction = (prompt_id, setEditModalOpen) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getPromptByIdConfig(prompt_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getPromptsByIdSlice(response));
        setEditModalOpen(true);
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const editPromptAction = (
  prompt_id,
  payload,
  setIsOpen,
  setSegmentedButtons,
  selectedSpecialty,
  selectedCondition,
  setRemovedIndices,
  setUpdatedStaticPromptPayload
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = editPromptConfig(prompt_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        showToastSuccess('Prompt edited successfully');
        dispatch(superAdminLoadingSlice(false));
        setIsOpen(false);
        dispatch(getFilterPrompt(selectedSpecialty, selectedCondition));
        setSegmentedButtons([]);
        setRemovedIndices && setRemovedIndices([]);
        setUpdatedStaticPromptPayload && setUpdatedStaticPromptPayload([]);
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const deletePromptAction = (
  prompt_id,
  setIsOpen,
  selectedSpecialty,
  selectedCondition
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = deletePromptConfig(prompt_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Prompt deleted successfully');
        dispatch(superAdminLoadingSlice(false));
        setIsOpen(false);
        dispatch(getFilterPrompt(selectedSpecialty, selectedCondition));
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const getAllPromptsScreens = () => {
  return async (dispatch) => {
    try {
      const { url } = getAllPromptScreensConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.prompt_screens;
      if (result?.status === 200 && response) {
        dispatch(getPromptScreensSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getAllConditionPromptAction = (payload) => {
  return async (dispatch) => {
    try {
      const { url } = getAllConditionPromptConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getConditionPromptSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getAllPromptScreenConditionAction = (payload) => {
  return async (dispatch) => {
    try {
      const { url } = getAllPromptScreenConditionConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data?.missing_conditions;
      if (result?.status === 200 && response) {
        dispatch(getPromptScreenConditionSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getFilterPrompt = (specialty_id, condition_id) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getFilterPromptConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const payload = {
        specialty_id: specialty_id,
        condition_id: condition_id,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data?.Prompts;
      if (result?.status === 200 && response) {
        dispatch(getAllPromptsListSlice(response));
        dispatch(superAdminLoadingSlice(false));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};
